// F-VERSIONS — plug the real Versions pane into the F-SHELL registry seam.
//
// Same seam proof as F-SOURCES / F-PLAN (plan §2.1): the feature self-registers
// via this `register.ts`, the barrel `features/index.ts` imports it as a
// side-effect, and the shell renders the Pane — with ZERO edit to any shared
// shell file. The acceptance gate is an EMPTY `git diff main -- src/ui/shell/`.
//
// `labelKey` REUSES the F-SHELL key `shell.tab.versions` (does not duplicate
// it); `order: 50` matches the FROZEN `KNOWN_TABS` slot (versions=50).

import { createElement } from 'react'
import { registerTab } from '@/ui/shell/tab-registry'
import { VersionsPane } from './VersionsPane'

registerTab({
  id: 'versions',
  order: 50,
  labelKey: 'shell.tab.versions',
  // Neutral clock/history glyph (RTL-agnostic — not a direction-implying icon,
  // so no scaleX flip needed per CLAUDE.md §9.2 rule 3).
  icon: createElement('span', { 'aria-hidden': true }, '🕑'),
  Pane: VersionsPane,
})
